import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCdmbaPlysVtGHR4LevdO76dI4NyEAgtto",
  authDomain: "cocowash.firebaseapp.com",
  projectId: "cocowash",
  storageBucket: "cocowash.firebasestorage.app",
  messagingSenderId: "1012524108190",
  appId: "1:1012524108190:web:4e2f4528f3f37aefb7ae8f"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app);
export default app;
